/* eslint-disable no-shadow */
/* eslint-disable import/no-cycle */
import {
  ActionTree, Module, GetterTree, MutationTree
} from 'vuex';
import IRootState from '../states/interfaces/index.d';
import IAddressState from '../states/interfaces/address-state.d';
import AddressState from '../states/address-state';

export const state: IAddressState = new AddressState();
export const getters: GetterTree<IAddressState, IRootState> = {
  address: (state) => state.address
};

export const mutations: MutationTree<IAddressState> = {
  setBuildingName: (state: AddressState, buildingName: string) => {
    state.address.buildingName = buildingName;
  },
  setSubBuildingName: (state: AddressState, subBuildingName: string) => {
    state.address.subBuildingName = subBuildingName;
  },
  setBuildingNumber: (state: AddressState, buildingNumber: string) => {
    state.address.buildingNumber = buildingNumber;
  },
  setStreet: (state: AddressState, street: string) => {
    state.address.street = street;
  },
  setDependentLocality: (state: AddressState, dependentLocality: string) => {
    state.address.dependentLocality = dependentLocality;
  },
  setTown: (state: AddressState, town: string) => {
    state.address.town = town;
  },
  setSubStreet: (state: AddressState, subStreet: string) => {
    state.address.subStreet = subStreet;
  },
  setOrganisationName: (state: AddressState, organisationName: string) => {
    state.address.organisationName = organisationName;
  },
  setPostcode: (state: AddressState, postcode: string) => {
    state.address.postcode = postcode;
  },
  setSubNationalArea: (state: AddressState, subNationalArea: string) => {
    state.address.subNationalArea = subNationalArea;
  },
  setCountry: (state: AddressState, country: string) => {
    state.address.country = country;
  },
  setLatitude: (state: AddressState, latitude: number) => {
    state.address.latitude = latitude;
  },
  setLongitude: (state: AddressState, longitude: number) => {
    state.address.longitude = longitude;
  }
};

export const actions: ActionTree<IAddressState, IRootState> = {
  submitBuildingName({ commit }, buildingName: string) {
    commit('setBuildingName', buildingName);
  },
  submitSubBuildingName({ commit }, subBuildingName: string) {
    commit('setSubBuildingName', subBuildingName);
  },
  submitBuildingNumber({ commit }, buildingNumber: string) {
    commit('setBuildingNumber', buildingNumber);
  },
  submitStreet({ commit }, street: string) {
    commit('setStreet', street);
  },
  submitDependentLocality({ commit }, dependentLocality: string) {
    commit('setDependentLocality', dependentLocality);
  },
  submitTown({ commit }, town: string) {
    commit('setTown', town);
  },
  submitSubStreet: ({ commit }, subStreet: string) => {
    commit('setSubStreet', subStreet);
  },
  submitOrganisationName: ({ commit }, organisationName: string) => {
    commit('setOrganisationName', organisationName);
  },
  submitPostcode({ commit }, postcode: string) {
    commit('setPostcode', postcode);
  },
  submitSubNationalArea({ commit }, subNationalArea: string) {
    commit('setSubNationalArea', subNationalArea);
  },
  submitCountry({ commit }, country: string) {
    commit('setCountry', country);
  },
  submitLatitude({ commit }, latitude: number) {
    commit('setLatitude', latitude);
  },
  submitLongitude({ commit }, longitude: number) {
    commit('setLongitude', longitude);
  }
};
export const addressModule: Module<IAddressState, IRootState> = {
  state,
  actions,
  getters,
  mutations,
  namespaced: true
};
